// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.human-body-map {
  max-width: 60%;
  max-height: 600px;
  overflow: visible;
}
.human-body-map .pin-group:hover .pin {
  fill: #1fb1e6;
}
.human-body-map .pin-group .pin {
  transition: all 0.3s ease;
  /* cursor: pointer; */
  transform-origin: center;
}
.human-body-map .pin-group .info {
  transition: all 0.3s ease;
  /* pointer-events: none; */
  cursor: default;
  /* opacity: 0; */
}
.human-body-map .pin-group .info rect {
  fill: white;
  filter: drop-shadow(2px 1px 26px rgba(101, 96, 240, 0.25));
}
.human-body-map .pin-group .info text {
  font-size: 45px;
  fill: #8E8DA1;
}
.human-body-map .pin-group:hover .info {
  opacity: 1;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
